import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "select", "other", "submit" ]

  connect() {
    this.updateState()
  }

  updateState() {
    const isOther = this.selectTarget.value === "__other__"

    this.otherTarget.classList.toggle("hidden", !isOther)
    this.otherTarget.required = isOther

    if (isOther) {
      this.otherTarget.value = this.otherTarget.dataset.lastValue || ""
      this.submitTarget.disabled = this.otherTarget.value.trim() === ""
    } else {
      this.submitTarget.disabled = this.selectTarget.value === ""
    }
  }

  selectChanged() {
    if (this.selectTarget.value !== "__other__") {
      this.otherTarget.dataset.lastValue = this.otherTarget.value
      this.otherTarget.value = ""
    }
    this.updateState()
  }

  otherChanged() {
    if (this.selectTarget.value === "__other__") {
      this.submitTarget.disabled = this.otherTarget.value.trim() === ""
    }
  }
}
